import React, { useEffect, useMemo, useState } from 'react';
import Zendesk from 'react-zendesk';

import { useOrganizationOverridableProperties } from '@/modules/core/hooks/useOrganizationOverridableProperties';

import { cleanUpZendesk } from './cleanUpZendesk';

const SETTINGS = {
  webWidget: {
    offset: { vertical: '50px' },
  },
};

export default () => {
  const [isMounted, setIsMounted] = useState(false);
  const { observingOrganizationData } = useOrganizationOverridableProperties();
  const zendeskKey = useMemo(() => observingOrganizationData?.adminChatbotLink, [observingOrganizationData]);

  useEffect(() => {
    if (zendeskKey) {
      setIsMounted(true);
    }
  }, [zendeskKey]);

  useEffect(() => {
    return () => {
      cleanUpZendesk();
      setIsMounted(false);
    };
  }, [zendeskKey]);

  if (!zendeskKey || !isMounted) {
    return null;
  }

  return (
    <Zendesk
      defer
      key={zendeskKey}
      zendeskKey={zendeskKey}
      {...SETTINGS}
    />
  );
};
